/**
 * create exprted function,
 * this is reduce bundle size.
 */
export function encode(value, strFrom, strTo) {
  if (value === undefined || value === null || value === "") {
    return value;
  }
  return value.replace(new RegExp(strFrom, "g"), strTo);
}
